// controllers
import GateController from '../../../assets/js/controllers/gate';
import ModalController from '../../../assets/js/controllers/modal';

// constants
import GateEvent from '../../../assets/js/constants/gate-event';

// helpers
import { wistiaReveal } from '../../../assets/js/helpers';

export default class SubmoduleHeroWebinar {

	static selector = 'submodule-hero-webinar';

	// class variables

	config = {
		modalId: null,
		wistiaId: null
	};

	el = {};

	flags = {
		isPendingGate: false
	};

	states = {
		activeDescription: null,
		total: 0,
		wistiaApiRef: null
	};

	// constructor

	constructor(container) {
		this.el = {
			container,
			ctaPlay: container.querySelector(`.${this.constructor.selector}__video-cta-play`),
			wistiaVideo: container.querySelector(`.${this.constructor.selector}__video-wistia`)
		};

		this.config.modalId = this.el.container.dataset.modalId;
		this.config.wistiaId = this.el.container.dataset.wistiaId;

		this.initialize();
	}

	// initialize

	initialize() {
		this.#addEventListeners();
	}

	// add and remove listeners

	#addEventListeners = () => {
		this.el.ctaPlay.addEventListener('click', this.#onVideoPlayClick);
		document.body.addEventListener(GateEvent.CANCEL, this.#onGateCancel);
		document.body.addEventListener(GateEvent.UNLOCK, this.#onGateUnlocked);
	}

	#removeEventListeners = () => {
		this.el.ctaPlay.removeEventListener('click', this.#onVideoPlayClick);
		document.body.removeEventListener(GateEvent.CANCEL, this.#onGateCancel);
		document.body.removeEventListener(GateEvent.UNLOCK, this.#onGateUnlocked);
	}

	// listener methods

	#onVideoPlayClick = () => {
		if (GateController.needsGate(this.config.modalId)) {
			this.flags.isPendingGate = true;
			ModalController.open(this.config.modalId);
		} else {
			this.wistiaPlay();
		}
	}

	#onGateCancel = () => {
		this.flags.isPendingGate = false;
	}

	#onGateUnlocked = () => {
		if (this.flags.isPendingGate) {
			this.flags.isPendingGate = false;
			this.wistiaPlay();
		}
	}

	//

	wistiaPlay() {
		if (!this.states.wistiaApiRef) {
			this.states.wistiaApiRef = Wistia.api(this.config.wistiaId);
		}

		this.el.wistiaVideo.classList.add('is-active');
		this.states.wistiaApiRef.play();

		wistiaReveal(this.states.wistiaApiRef).then(() => {
			this.el.wistiaVideo.classList.add('is-in');
		});
	}

	// destroy

	destroy() {
		this.#removeEventListeners();
	}

}
